function ServiziRapidi({ flag, dettagliIsOpen }) {

    return (<>
        <div className={`divNotifiche${flag === 'primoServizi' || flag === 'primoArtisti' || flag === 'primoFornitori' ? 'Aperto' : ''}`}
            style={{ marginTop: '-4em', height: '100%', padding: '3px', zIndex: '1' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => {
                    window.history.back()
                }}>◀
            </button><hr />
            <p className='mt-3 p-1 text-center'><b>COLLABORATORI PER EVENTI</b></p>
            <div className='mt-5'>
                <button style={{ width: '100%' }} onClick={() => { dettagliIsOpen('primoArtisti', 'artisti') }}>ARTISTI PER EVENTI</button>
                <button style={{ width: '100%', marginTop: '1em' }} onClick={() => { dettagliIsOpen('primoArtisti', 'foodTruck') }}>FOODTRUCK PER EVENTI</button>
                <button style={{ width: '100%', marginTop: '1em' }} onClick={() => { dettagliIsOpen('primoFornitori') }}>FORNITORI PER EVENTI</button>
            </div>
        </div>
    </>)
}
export default ServiziRapidi